// @flow
import * as React from "react";
import { page } from "../../components/Auth/Page";

export const CapApplicationSubmitted = page(
  React.lazy(() => import("./containers/ApplicationSubmittedPage")),
);
